import { TextFieldProps } from '@mui/material/TextField';
import { Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { withSxProp } from 'common/utils/props';
import { TControllerProps } from 'common/types';
import { asTypedControl } from 'common/utils/form';
import { NumberInput } from 'common/forms/Field/NumberField/NumberInput';

interface IProps extends Omit<TextFieldProps, 'name'> {
    name: string;
    allowDecimals?: boolean;
}

export const NumberField = <TFieldValues extends FieldValues>({
    control: formControl,
    name,
    placeholder,
    sx,
    allowDecimals = true,
    ...other
}: IProps & TControllerProps<TFieldValues>) => {
    const { i18n } = useTranslation();
    const control = asTypedControl<number | null | undefined>(
        name,
        formControl
    );

    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState: { error } }) => (
                <NumberInput
                    allowDecimals={allowDecimals}
                    error={error?.message}
                    field={field}
                    locale={i18n.language}
                    textFieldProps={{
                        ...other,
                        placeholder,
                        slotProps: {
                            inputLabel: !!placeholder
                                ? { shrink: true }
                                : undefined,
                        },
                        sx: [
                            {
                                '.MuiOutlinedInput-input': {
                                    py: 2,
                                },
                            },
                            ...withSxProp(sx),
                        ],
                    }}
                />
            )}
        />
    );
};
